module.exports = __webpack_public_path__ + "img/fat-free-corn-bread.2fbb5416.jpg";